import React from 'react';
import { Table } from 'react-bootstrap';

import SubtleBadge from 'components/common/SubtleBadge';

import { PERMISSION_LABELS } from 'constants/admin/user';

const WarehousePermissionView = ({ permissions = [] }) => {
  if (!permissions.length) {
    return (
      <p className="text-muted mb-0">No warehouse permissions assigned.</p>
    );
  }

  return (
    <Table responsive striped bordered size="sm" className="mb-0">
      <thead>
        <tr>
          <th>Warehouse</th>
          <th className="text-center">Manager</th>
          <th className="text-center">Purchase Order</th>
          <th className="text-center">Gate Pass</th>
          <th className="text-center">Put Away</th>
        </tr>
      </thead>
      <tbody>
        {permissions.map(perm => (
          <tr key={perm.warehouse.id}>
            <td>{perm.warehouse.name}</td>
            <td className="text-center">
              <SubtleBadge pill bg={perm.is_manager ? 'success' : 'secondary'}>
                {perm.is_manager ? 'Yes' : 'No'}
              </SubtleBadge>
            </td>
            <td className="text-center">
              {PERMISSION_LABELS[perm.purchase_order] ?? perm.purchase_order}
            </td>
            <td className="text-center">
              {PERMISSION_LABELS[perm.gate_pass] ?? perm.gate_pass}
            </td>
            <td className="text-center">
              {PERMISSION_LABELS[perm.put_away] ?? perm.put_away}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default WarehousePermissionView;
